import { render, staticRenderFns } from "./GoogleSpreadsheetTemplates.vue?vue&type=template&id=4536142f&scoped=true"
import script from "./GoogleSpreadsheetTemplates.vue?vue&type=script&lang=ts"
export * from "./GoogleSpreadsheetTemplates.vue?vue&type=script&lang=ts"
import style0 from "./GoogleSpreadsheetTemplates.vue?vue&type=style&index=0&id=4536142f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4536142f",
  null
  
)

export default component.exports